import { API_PATH } from "./api-endpoints.dev";

export const environment = {
  production: true,
  api_url: '',
  routes: { ...API_PATH }
};
